import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold text-left text-[#163D45] mb-4" }, "Requisitos da escala", -1)
const _hoisted_3 = { class: "flex items-center gap-3" }

import { ref, onMounted, inject } from 'vue'
import DsSwitch from '@/components/designSystem/Switch/index.vue'
import { useCreateScheduleStore } from '@/pinia-store/useCreateScheduleStore'
import { storeToRefs } from 'pinia'
import ComboBoxWithOther from './ComboBoxWithOther.vue'
import FieldOptionsService from '@/Network/Services/FieldOptionsService'

type Item = { title: string; value: number }


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleRequirements',
  props: {
    errors: {},
    onClearError: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const store = (inject('createScheduleStore') ?? useCreateScheduleStore()) as ReturnType<
  typeof useCreateScheduleStore
>
const { step2 } = storeToRefs(store)

const positions = ref<Item[]>([])
const formations = ref<Item[]>([])
const shifts = ref<Item[]>([])

const fieldService = new FieldOptionsService()

const fetchFieldOptions = async () => {
  try {
    const [positionResponse, shiftsResponse, formationResponse] = await Promise.all([
      fieldService.getPositions(),
      fieldService.getShifts(),
      fieldService.getFormations()
    ])

    positions.value = positionResponse.map((position) => ({
      title: position.name,
      value: position.id
    }))

    formations.value = formationResponse.map((formation) => ({
      title: formation.name,
      value: formation.id
    }))

    shifts.value = shiftsResponse.map((shift) => ({
      title: shift.name,
      value: shift.id
    }))
  } catch (error) {
    console.error('Erro ao carregar dados dos campos:', error)
  }
}

onMounted(fetchFieldOptions)

// eslint-disable-next-line @typescript-eslint/no-unused-vars


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(ComboBoxWithOther, {
      modelValue: _unref(step2).positions,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_unref(step2).positions) = $event)),
        _cache[1] || (_cache[1] = ($event: any) => (props.onClearError('positions')))
      ],
      items: positions.value,
      label: "Selecione as posições da escala",
      error: !!props.errors.positions,
      "error-message": props.errors.positions
    }, null, 8, ["modelValue", "items", "error", "error-message"]),
    _createVNode(ComboBoxWithOther, {
      modelValue: _unref(step2).shifts,
      "onUpdate:modelValue": [
        _cache[2] || (_cache[2] = ($event: any) => ((_unref(step2).shifts) = $event)),
        _cache[3] || (_cache[3] = ($event: any) => (props.onClearError('shifts')))
      ],
      items: shifts.value,
      label: "Selecione os turnos da escala",
      error: !!props.errors.shifts,
      "error-message": props.errors.shifts
    }, null, 8, ["modelValue", "items", "error", "error-message"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", {
        class: _normalizeClass(["text-sm font-bold transition-colors", _unref(step2).formationRequired ? 'text-primary' : 'text-gray-400'])
      }, " Nível de formação necessário para a escala? ", 2),
      _createVNode(DsSwitch, {
        modelValue: _unref(step2).formationRequired,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(step2).formationRequired) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(ComboBoxWithOther, {
      modelValue: _unref(step2).formations,
      "onUpdate:modelValue": [
        _cache[5] || (_cache[5] = ($event: any) => ((_unref(step2).formations) = $event)),
        _cache[6] || (_cache[6] = ($event: any) => (props.onClearError('formations')))
      ],
      items: formations.value,
      label: "Selecione o nível de formações necessário para a escala",
      disabled: !_unref(step2).formationRequired,
      error: !!props.errors.formations,
      "error-message": props.errors.formations
    }, null, 8, ["modelValue", "items", "disabled", "error", "error-message"])
  ]))
}
}

})